const DEFAULT_LANGUAGE = 'en';
const MULTILANGUAGE_ENABLED = process.env.REACT_APP_MULTILANGUAGE_ENABLED == 'true'  ? true : false;
const LANGUAGE_PREFERENCE_FIELD = 'languagePreference';
const LANGUAGE_STORAGE_KEY = 'selectedLanguage';
const LANGUAGE_PROFILE_SYNC_PENDING_KEY = 'selectedLanguagePendingProfileSync';

//NOTE: de.json is not supported, so ignore updating de.json

const SUPPORTED_LANGUAGES = Object.freeze([
  Object.freeze({
    code: 'en',
    locale: 'en-US',
    momentLocale: 'en',
    label: 'English',
    shortLabel: 'EN',
    direction: 'ltr',
  }),
  Object.freeze({
    code: 'fr',
    locale: 'fr-FR',
    momentLocale: 'fr',
    label: 'Français',
    shortLabel: 'FR',
    direction: 'ltr',
  }),
  Object.freeze({
    code: 'es',
    locale: 'es-ES',
    momentLocale: 'es',
    label: 'Español',
    shortLabel: 'ES',
    direction: 'ltr',
  }),
  Object.freeze({
    code: 'ja',
    locale: 'ja-JP',
    momentLocale: 'ja',
    label: '日本語',
    shortLabel: 'JA',
    direction: 'ltr',
  }),
  Object.freeze({
    code: 'zh',
    locale: 'zh-CN',
    momentLocale: 'zh-cn',
    label: '中文',
    shortLabel: 'ZH',
    direction: 'ltr',
  }),
]);

const findSupportedLanguage = value => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim().toLowerCase();
  return (
    SUPPORTED_LANGUAGES.find(
      language =>
        language.code.toLowerCase() === normalizedValue ||
        language.locale.toLowerCase() === normalizedValue
    ) || null
  );
};

const normalizeLanguage = value =>
  findSupportedLanguage(value)?.code || DEFAULT_LANGUAGE;

module.exports = {
  DEFAULT_LANGUAGE,
  MULTILANGUAGE_ENABLED,
  LANGUAGE_PREFERENCE_FIELD,
  LANGUAGE_STORAGE_KEY,
  LANGUAGE_PROFILE_SYNC_PENDING_KEY,
  SUPPORTED_LANGUAGES,
  findSupportedLanguage,
  normalizeLanguage,
};
